import * as React from 'react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import Top from "../Top";

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import { FormControl, FormControlLabel, InputLabel, MenuItem, Modal, Radio, RadioGroup, Select, Typography } from '@mui/material';
import { FormContainer, PasswordElement, PasswordRepeatElement, set, TextFieldElement } from "react-hook-form-mui";

import ApartmentIcon from '@mui/icons-material/Apartment';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import WcIcon from '@mui/icons-material/Wc';
import FaceIcon from '@mui/icons-material/Face';
import Face4Icon from '@mui/icons-material/Face4';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import api from "../../utils/api";
import * as util from "../../utils/util";

const typeSaveBasicParam = {
  id: '', code: '',  companyId: '', type: '', userName: '', birthDate: '', cusId: '', phone: '', address: '', buildingNum: ''
  , email: '', zipCode: '', beforePassword: '', afterPassword: '', afterPasswordCheck: ''
};

const OfficeJoinPrivate = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = { ...location.state };
  const [saveBasicParam, setSaveBasicParam] = React.useState(typeSaveBasicParam);
  const [isEmployeeCheck, setIsEmployeeCheck] = React.useState(false);
  const [famName, setFamName] = React.useState('');
  const [famBirthDate, setFamBirthDate] = React.useState('');
  const [famRelation, setFamRelation] = React.useState('');
  const [grade, setGrade] = React.useState(userInfo.type === 'B2B' ? "가족" : "본인");
  const [alignment, setAlignment] = React.useState('1');
  const [famSelect, setFamSelect] = React.useState('none');

  // 2026년 예외기업
  const EXCEPTION_COMPANIES_2026 = ['CO#32', 'CO#33'];
  const isExceptionCompany = EXCEPTION_COMPANIES_2026.includes(saveBasicParam.companyId);

  useEffect(() => {
    setSaveBasicParam(userInfo);
  }, []);

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null,
  ) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
    }
  };

  // 회원 추가정보를 받기 위한 화면으로 이동
  async function handleSaveUser(data: any) {
    if (grade == "가족" && !isEmployeeCheck) {
      alert('직원 확인을 해주세요.');
    } else if (grade === '가족' && !(famRelation ?? '').trim()) {
      alert('관계를 선택해주세요.');
    } else {
      // 관계입력 수정 - 2026.02.02
      const familyInfo = buildFamilyInfo(grade, famName, famRelation);

      if (grade === '가족' && !familyInfo) {
        alert('가족 정보(이름/관계)를 모두 입력해주세요.');
        return;
      }

      const updatedProfile = {
        ...saveBasicParam,
        name: data.userName,
        birthDate: `${data.birthDate.substring(0, 4)}-${data.birthDate.substring(4, 6)}-${data.birthDate.substring(6, 8)}`,
        sex: alignment !== '0',
        family_info: familyInfo,
      };

      navigate('/Join/OfficeJoinContact', { state: updatedProfile });
    }
  }
  
  function isBrithDate(text: any) {
    return ((/^[0-9]{8}$/).test(text));
  }

  function buildFamilyInfo(grade: string, famName: any, famRelation: any): string | null {
    if (grade === '퇴직자') return '퇴직자';
    if (grade !== '가족') return '본인';
    const name = (famName ?? '').trim();
    const relation = (famRelation ?? '').trim();
    if (!name || !relation) return null;
    return `${name}의 ${relation}`;
  }

  function choiceType(e: any) {
    const value = e.target.value;
    setGrade(value);

    setIsEmployeeCheck(false);
    setFamName('');
    setFamBirthDate('');
    setFamRelation('');
    setFamSelect('none')
  }

  return (
    <Container sx={Logbg}>
      <Top title="회원 가입" />

      <Stack direction={'column'} sx={{ justifyContent: 'center', alignContent: 'center' }}>
        <FormContainer
          values={{ userName: saveBasicParam.userName, birthDate: saveBasicParam.birthDate, famName: famName, famBirthDate: famBirthDate, famRelation: famRelation }}
          onSuccess={data => handleSaveUser(data)}
        >

          <Card sx={{ p: '0px 20px 30px 20px', bgcolor: '#fff' }}>
            <Divider sx={{ fontSize: 18, mb: 2, mt: 2.5, fontWeight: 700 }}>개인 정보</Divider>

            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="grade"
                defaultValue={grade}
                onChange={choiceType}
              >
                {
                  // 2026년 예외기업
                  saveBasicParam.type === 'B2B' && !isExceptionCompany
                    ? ''
                    : <FormControlLabel value="본인" control={<Radio />} label="회원본인" />
                }
                <FormControlLabel value="가족" control={<Radio />} label="가족" />
                <FormControlLabel value="퇴직자" control={<Radio />} label="퇴직자" />
              </RadioGroup>
            </Box>

            {
              grade === '가족'
                ? <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 3, width: '100%' }}>
                    <Box>
                      <Box sx={{ display: 'flex', alignItems: 'flex-end', width: '100%' }}>
                        <AssignmentIndIcon sx={profileIcon} />
                        <TextFieldElement
                          name="famName"
                          id="input-userName" label="직원이름" variant="standard"
                          fullWidth
                          rules={{
                            required: '필수 입력입니다.',
                          }}
                          onChange={(e: any) => {
                            setFamName(e.target.value);
                          }}
                          inputProps={{ readOnly: isEmployeeCheck }}
                          sx={loginField}
                        />
                        <CalendarMonthIcon sx={profileIcon} />
                        <TextFieldElement
                          name="famBirthDate"
                          id="input-birth" label="생년월일" variant="standard"
                          placeholder='YYYYMMDD'
                          fullWidth
                          rules={{
                            required: '필수 입력입니다.',
                          }}
                          onChange={(e: any) => {
                            setFamBirthDate(e.target.value);
                          }}
                          inputProps={{ readOnly: isEmployeeCheck }}
                          sx={loginField}
                        />
                      </Box>
                    </Box>

                    <Button onClick={() => {
                      if (!isEmployeeCheck) {
                        if (util.strNull(famName) !== '' && util.strNull(famBirthDate) !== '') {
                          if (!isBrithDate(famBirthDate)) {
                            alert('생년월일 형식을 확인해주세요.');
                          } else {
                            api.get('permission/companies/check', { params: { code: saveBasicParam.code, name: famName, birthDate: famBirthDate } }).then(res => {
                              if (res.data.data.employee == null) {
                                alert('등록된 직원이 아닙니다.');
                                return;
                              }

                              setFamSelect('flex');
                              setIsEmployeeCheck(res.data.success);
                              if (!res.data.success) {
                                alert(res.data.message);
                              } else {
                                alert('직원 확인되었습니다.');
                              }
                            }).catch(function (error) {
                              console.log(error);
                            });
                          }
                        } else {
                          if (util.strNull(famName) === '') {
                            alert('이름 입력 후 시도해주세요.');
                          } else if (util.strNull(famBirthDate) === '') {
                            alert('생년월일 입력 후 시도해주세요.');
                          }
                        }
                      } else {
                        alert('직원 확인되었습니다.');
                      }
                    }}
                      sx={{ fontSize: 12, minWidth: 70, border: '1px solid #ed6c02', borderRadius: 20, color: '#ed6c02', bgcolor: '#ed6c0214', fontWeight: 700, p: .5 }}
                    >
                      직원확인
                    </Button>
                  </Box>
                : null
            }

            <Box sx={{ display: famSelect, alignItems: 'flex-end', mb: 2, width: '100%' }}>
              <WcIcon sx={profileIcon} />
              <FormControl fullWidth sx={loginField}>
                <InputLabel id="select-label-active" sx={{ fontSize: 14 }} >관계</InputLabel>
                <Select
                  labelId="select-label-active"
                  id="select-label-active"
                  name='famRelation'
                  // defaultValue="부모"
                  value={famRelation}
                  displayEmpty
                  label="관계"
                  variant="standard"
                  sx={loginField}
                  onChange={(e: any) => {
                    setFamRelation(e.target.value);
                  }}
                >
                  <MenuItem value="" disabled>
                    관계를 선택해주세요
                  </MenuItem>

                  <MenuItem value="부모">부모</MenuItem>
                  <MenuItem value="배우자">배우자</MenuItem>
                  <MenuItem value="자녀">자녀</MenuItem>
                  <MenuItem value="형제/자매">형제/자매</MenuItem>
                  <MenuItem value="친척">친척</MenuItem>
                </Select>
              </FormControl>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2, width: '100%' }}>
              <AssignmentIndIcon sx={profileIcon} />
              <TextFieldElement
                name="userName"
                id="input-userName" label="이름" variant="standard"
                fullWidth
                inputProps={{ readOnly: true }}
                sx={loginField}
              />
              {/*<Button sx={{ fontSize: 12, minWidth: 70, border: '1px solid #ed6c02', borderRadius: 20, color: '#ed6c02', bgcolor: '#ed6c0214', fontWeight: 700, p: .5 }}>
                본인인증
              </Button>*/}
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2, width: '100%' }}>
              <CalendarMonthIcon sx={profileIcon} />
              <TextFieldElement
                name="birthDate"
                id="input-birth" label="생년월일" variant="standard"
                fullWidth
                inputProps={{ readOnly: true }}
                sx={loginField}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2, width: '100%' }}>
              <WcIcon sx={profileIcon} />
              <Stack direction={'row'} alignItems={'baseline'} sx={{ borderBottom: '1px solid #bbb', width: '100%' }}>
                <Typography gutterBottom sx={{ color: '#888', fontSize: 16, }}>성별</Typography>
                <ToggleButtonGroup
                  color="warning"
                  size="small"
                  value={alignment}
                  exclusive
                  onChange={handleChange}
                  aria-label="sex"
                  sx={{ width: '75%', ml: 'auto' }}
                >
                  <ToggleButton value="1" fullWidth><FaceIcon /></ToggleButton>
                  <ToggleButton value="0" fullWidth><Face4Icon /></ToggleButton>
                </ToggleButtonGroup>
              </Stack>
            </Box>

          </Card>

          <Box sx={{ p: '10px 0px 30px 0px' }}>
            <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ mt: 3, bgcolor: '#ffb068', borderRadius: '20px' }}>
              {/* <CareButton variant="contained" sx={{ bgcolor: '#FFB068', color: '#fff' }} onClick={() => navigate('../Join/Join')} >
                취소
              </CareButton> */}

              <CareButton variant="contained" type={'submit'}>
                다음
              </CareButton>
            </Stack>
          </Box>
        </FormContainer>

      </Stack>

    </Container>
  );
}

const profileIcon = {
  color: '#888', mr: 1, my: 0.5, fontSize: 20
}

const CareButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '10px 30px',
  lineHeight: 1.5,
  backgroundColor: '#EF8322',
  borderColor: '#EF8322',
  borderRadius: '20px',
  width: '100%',
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  '&:focus': {
    boxShadow: 'none',
  },
});

const loginField = {
  '& input': {
    fontSize: 15
  },
  '& label': {
    color: '#888',
    fontSize: 16,
    transform: 'translate(0, -1.5px) scale(0.75)'
  },
  '& label.Mui-focused': {
    color: '#ef8322',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#ef8322',
  },
  '& .MuiInputBase-root:before': {
    borderBottomColor: '#bbb',
  }
};

const Logbg = {
  bgcolor: '#f6f6f6',
  height: '100%',
  minHeight: '100vh',
  pb: 4,
  minWidth: '320px',
  pt: 10,
}

export default OfficeJoinPrivate;